import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {similarProductsSelector, sizeSelector, gaSelector} from "./selectors";
import withErrorBoundary from "../../../decorators/withErrorBoundary";
import ProductCards from "../ProductCards";

function SimilarProducts(props) {
  const {similarProducts, size, ga} = props;

  return (
    <ProductCards title="Рекомендуемые товары" products={similarProducts} size={size} ga={ga} />
  );
}

SimilarProducts.propTypes = {
  similarProducts: PropTypes.array,
  size: PropTypes.string,
  ga: PropTypes.shape({
    categoty: PropTypes.string,
  }),
};

const mapStateToProps = (state) => {
  return {
    similarProducts: similarProductsSelector(state),
    size: sizeSelector(state),
    ga: gaSelector(state),
  };
};

export default connect(mapStateToProps)(withErrorBoundary(SimilarProducts));
